import { createApp } from 'vue';
import { initFormKitSchema } from 'shared/utils/initFormKitSchema';
import HcpSignUpArea from './HcpSignUpArea.vue';
import HcpConsentArea from './HcpConsentArea.vue';
import './HcpSignUpConsentBlock.scss';

async function mountHcpSignUpConsentBlock() {
	const hcpSignUpConsentBlock = document.getElementById(
		'hcp-signup-consent-block',
	);

	if (!hcpSignUpConsentBlock) {
		console.warn('[HcpSignUpConsentBlock] Container not found');
		return;
	}

	const app = createApp({
		name: 'HcpSignUpConsentBlockApp',
	});
	app.component('hcp-signup-area', HcpSignUpArea);
	app.component('hcp-consent-area', HcpConsentArea);
	await initFormKitSchema(app);
	app.mount(hcpSignUpConsentBlock);
}

mountHcpSignUpConsentBlock().catch((error) => {
	console.error('Error mounting HcpSignUpConsentBlock:', error);
});

